module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasTeacherPermissionsInCourse) ? _c('div', {
    staticClass: "flex items-center justify-center font-manrope"
  }, [_c('div', {
    staticClass: "relative w-full max-w-2xl"
  }, [_c('div', {
    staticClass: "flex flex-col items-center justify-center relative"
  }, [_c('div', {
    staticClass: "h-12 w-12 rounded-full bg-white border border-gray-200 flex items-center justify-center"
  }, [_vm._v("\n        🌟\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col items-center justify-center px-2 pt-6 pb-6 text-center"
  }, [_c('h2', {
    staticClass: "font-poppins text-xl font-semibold text-slate-900"
  }, [_vm._v("\n          It's almost showtime\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "mt-2 text-sm leading-6 text-slate-600"
  }, [_vm._v("\n          Get everything ready in a few steps and kick off the discussion.\n        ")]), _vm._v(" "), _c('ol', {
    staticClass: "flex items-center text-left mt-5 space-x-4"
  }, _vm._l((_vm.discussionSteps), function(step, idx) {
    return _c('li', {
      key: step.label,
      staticClass: "flex items-center"
    }, [_c('i', {
      staticClass: "text-lg",
      class: step.done ? 'fa-solid fa-circle-check text-green-600' : 'far fa-circle text-slate-400'
    }), _vm._v(" "), _c('div', {
      staticClass: "ml-3"
    }, [_c('div', {
      staticClass: "text-sm font-semibold text-slate-800"
    }, [_vm._v("\n                " + _vm._s(idx + 1) + ".\n                "), _c('button', {
      staticClass: "hover:underline",
      on: {
        "click": function($event) {
          return step.action()
        }
      }
    }, [_vm._v("\n                  " + _vm._s(step.label) + "\n                ")])])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "mt-6 text-sm text-gray-800 font-manrope cursor-pointer hover:underline",
    on: {
      "click": _vm.handleOpenWelcomeModal
    }
  }, [_vm._v("\n          How does this work?\n        ")])])])])]) : _c('div', [_c('div', {
    staticClass: "w-full text-center rounded-2xl px-6 py-8"
  }, [_c('div', {
    staticClass: "relative mx-auto h-12 w-12 rounded-full bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 flex items-center justify-center"
  }, [_c('svg', {
    staticClass: "h-6 w-6 text-slate-700 dark:text-slate-200",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "9",
      "stroke-width": "1.6"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "stroke-width": "1.6",
      "d": "M12 7v5l3 2"
    }
  })])]), _vm._v(" "), _c('h3', {
    staticClass: "mt-4 font-poppins text-lg font-semibold text-slate-900 dark:text-slate-50"
  }, [_vm._v("\n      The discussion hasn't started yet\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "mt-2 text-sm leading-6 text-slate-600 dark:text-slate-400"
  }, [_vm._v("\n      Please hang tight — the session will begin once the teacher starts it.\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "mt-3 text-slate-500 dark:text-slate-400"
  }, [_vm._v("\n      If nothing changes for a while, try refreshing the page.\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-4f8e58c3!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/liveDiscussion/tabs/DiscussionTab/VerbalDiscussionOffline.vue
// module id = 1789
// module chunks = 61